import { ImportSetItem } from '../types-store';

export const hasChanges = (item?: ImportSetItem, original?: ImportSetItem): boolean => {

  const compare = item?.importDatabaseId !== original?.importDatabaseId ||
    item?.criteriaDomain?.value !== original?.criteriaDomain?.value ||
    item?.importConstraintSet?.value !== original?.importConstraintSet?.value ||
    item?.disabled?.getTime() !== original?.disabled?.getTime()

  if (compare) {
    return true;
  }

  const language = ((item ?? {}).language ?? [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);
  const originalLanguage = ((original || {}).language || [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);

  if (language.length !== originalLanguage.length) {
    return true;
  }

  if (language.some(
    languageItem => !originalLanguage.some(
      originalLanguageItem => (languageItem.value ?? '') === (originalLanguageItem.value ?? '') &&
        (languageItem.description ?? '') === (originalLanguageItem.description ?? ''))
  )) {
    return true;
  }

  return false;
};
